<template>
  <div class="verification-content">
    <div class="left-section">
      <a-affix :offset-top="10">
        <div class="upload-item">
          <div class="upload-box">
            <a-icon type="plus-circle" class="upload-icon" />
            <span>请上传营业执照</span>
          </div>

          <div class="clearfix">
            <a-upload
              action="https://api.jssyjt.net/external-service-center/baiduRecognize/businessLicense"
              :headers="uploadHeaders"
              list-type="picture-card"
              :file-list="businessLicense"
              @preview="handlePreview"
              @change="handleBusinessLicenseChange"
              :multiple="false"
              :show-upload-list="true"
              accept=".jpg,.png"
              :data="{ idCardSide: 'front' }"
            >
              <div v-if="businessLicense.length < 1">
                <a-icon type="plus" />
                <div class="ant-upload-text">请上传图片</div>
              </div>
            </a-upload>
            <a-modal
              :visible="previewVisible"
              :footer="null"
              @cancel="previewHandleCancel"
            >
              <img alt="营业执照" style="width: 100%" :src="previewImage" />
            </a-modal>
          </div>
          <div class="error-msg" style="margin-top: 15px">
            <span>温馨提示，营业执照支持上传图片</span>
          </div>
        </div>
      </a-affix>
    </div>

    <!-- 分割线 -->
    <div class="vertical-divider"></div>

    <!-- 右侧表单 -->
    <div class="right-section">
      <a-form-model
        :model="formData"
        :rules="rules"
        ref="baseForm"
        layout="horizontal"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-form-model-item label="企业名称" prop="companyName">
          <a-input
            v-model="formData.companyName"
            placeholder="请输入企业名称"
          />
        </a-form-model-item>

        <a-form-model-item label="是否国资" prop="stateOwned">
          <a-radio-group v-model="formData.stateOwned">
            <a-radio :value="1"> 是 </a-radio>
            <a-radio :value="0"> 否 </a-radio>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item label="经济类型" prop="economicType">
          <a-select
            placeholder="请选择经济类型"
            v-model="formData.economicType"
            :not-found-content="fetching.economicType ? undefined : null"
            @dropdownVisibleChange="economicTypeDictionaries"
          >
            <a-spin
              v-if="fetching.economicType"
              slot="notFoundContent"
              size="small"
            />
            <a-select-option
              v-else
              v-for="economicType in dictionaries.economicType"
              :key="economicType.value"
            >
              {{ economicType.note }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="统一信用代码" prop="unifySocialCreditCodes">
          <a-input
            v-model="formData.unifySocialCreditCodes"
            placeholder="请输入统一信用代码"
          />
        </a-form-model-item>

        <a-form-model-item label="法定代表人" prop="legalPerson">
          <a-input
            v-model="formData.legalPerson"
            placeholder="请输入法定代表人"
          />
        </a-form-model-item>

        <a-form-model-item label="住所" prop="registeredAddress">
          <a-input
            v-model="formData.registeredAddress"
            placeholder="请输入住所"
          />
        </a-form-model-item>

        <a-form-model-item label="注册资本" prop="registeredCapital">
          <a-input
            v-model="formData.registeredCapital"
            placeholder="请输入注册资本"
          />
        </a-form-model-item>

        <a-form-model-item label="注册资本币种" prop="currency">
          <a-select
            placeholder="请选择注册资本币种"
            v-model="formData.currency"
            :not-found-content="fetching.currency ? undefined : null"
            @dropdownVisibleChange="currencyDictionaries"
          >
            <a-spin
              v-if="fetching.currency"
              slot="notFoundContent"
              size="small"
            />
            <a-select-option
              v-else
              v-for="currency in dictionaries.currency"
              :key="currency.value"
            >
              {{ currency.note }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="所属集团" prop="group">
          <a-tree-select
            v-model="formData.group"
            show-search
            labelInValue
            :tree-data="affiliatedTreeData"
            :expandedKeys="treeExpandedKeys"
            :autoExpandParent="true"
            :filterTreeNode="false"
            @search="onAffiliatedTreeSearch"
            :searchValue="affiliatedTreeSearchValue"
            style="width: 100%"
            placeholder="请选择所属集团"
            searchPlaceholder="请输入需要查询的集团名称"
            dropdownMatchSelectWidth
            :dropdown-style="{ maxHeight: '600px', overflow: 'auto' }"
            @focus="handleAffiliatedTreeVisible"
          >
            <a-spin
              v-if="affiliatedTreeLoading"
              slot="notFoundContent"
              size="small"
            />
          </a-tree-select>
        </a-form-model-item>

        <a-form-model-item label="监管部门" prop="supervisionDepartment">
          <a-tree-select
            v-model="formData.supervisionDepartment"
            show-search
            labelInValue
            :tree-data="regulatoryTreeData"
            :expandedKeys="treeExpandedKeys"
            :autoExpandParent="true"
            :filterTreeNode="false"
            @search="onRegulatoryTreeSearch"
            :searchValue="regulatoryTreeSearchValue"
            style="width: 100%"
            placeholder="请选择权利人监管部门"
            searchPlaceholder="请输入需要查询的监管部门"
            dropdownMatchSelectWidth
            :dropdown-style="{ maxHeight: '600px', overflow: 'auto' }"
            @focus="handleRegulatoryTreeVisible"
          >
            <a-spin
              v-if="regulatoryTreeLoading"
              slot="notFoundContent"
              size="small"
            />
          </a-tree-select>
        </a-form-model-item>

        <a-form-model-item label="是否为出租方" prop="isLessor">
          <a-radio-group v-model="formData.isLessor">
            <a-radio :value="1"> 是 </a-radio>
            <a-radio :value="0"> 否 </a-radio>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item label="成立日期" prop="establishmentDate">
          <a-date-picker
            style="width: 100%"
            placeholder="请选择起始时间"
            v-model="formData.establishmentDate"
          />
        </a-form-model-item>

        <a-form-model-item label="长期经营" prop="isLongTime">
          <a-radio-group v-model="formData.isLongTime">
            <a-radio :value="1"> 是 </a-radio>
            <a-radio :value="0"> 否 </a-radio>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item label="营业期限" required>
          <a-form-model-item
            prop="operatingPeriodStartDate"
            :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }"
          >
            <a-date-picker
              style="width: 100%"
              placeholder="请选择起始时间"
              v-model="formData.operatingPeriodStartDate"
              :disabled-date="disabledRentStartDate"
              @change="startDateRentChange"
            />
          </a-form-model-item>
          <span
            :style="{
              display: 'inline-block',
              width: '24px',
              textAlign: 'center',
            }"
          >
            -
          </span>
          <span v-if="formData.isLongTime">长期有效</span>
          <a-form-model-item
            prop="operatingPeriodEndDate"
            v-else
            :style="{ display: 'inline-block', width: 'calc(50% - 12px)' }"
          >
            <a-date-picker
              style="width: 100%"
              placeholder="请选择到期时间"
              v-model="formData.operatingPeriodEndDate"
              :disabled-date="disabledRentEndDate"
              @change="endDateRentChange"
            />
          </a-form-model-item>
        </a-form-model-item>

        <a-form-model-item label="经营范围" prop="businessScope">
          <a-textarea
            class="textarea-auto"
            placeholder="请输入经营范围"
            v-model="formData.businessScope"
            :rows="4"
          />
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import storage from "store";
import { ACCESS_TOKEN } from "@/store/mutation-types";
import {
  getCurrency,
  getEconomicType,
  getOrgTree,
  getOrgList,
} from "@/api/shexgrp/Dictionaries.js";
export default {
  computed: {
    uploadHeaders() {
      const token = storage.get(ACCESS_TOKEN);
      return {
        Authorization: token ? token : "",
      };
    },
  },
  data() {
    return {
      fetching: {
        currency: false,
        economicType: false,
      },
      dictionaries: {
        currency: [],
        economicType: [],
      },
      affiliatedOriginTreeData: [],
      regulatoryOriginTreeData: [],
      affiliatedTreeLoading: false,
      regulatoryTreeLoading: false,
      affiliatedTreeData: [],
      regulatoryTreeData: [],
      affiliatedTreeSearchValue: "",
      regulatoryTreeSearchValue: "",
      treeExpandedKeys: [],
      businessLicense: [],
      state: {
        loginBtn: false,
      },
      formData: {
        companyName: undefined,
        stateOwned: 1,
        //经济类型
        economicType: undefined,
        unifySocialCreditCodes: undefined,
        legalPerson: undefined,
        registeredAddress: undefined,
        registeredCapital: undefined,
        //币种
        currency: undefined,
        //所属集团
        group: undefined,
        //监管部门
        supervisionDepartment: undefined,
        isLessor: 1,
        establishmentDate: undefined,
        isLongTime: 1,
        operatingPeriodStartDate: undefined,
        operatingPeriodEndDate: undefined,
        businessScope: undefined,
      },
      rules: {
        companyName: [{ required: true, message: "请输入企业名称" }],
        stateOwned: [{ required: true, message: "请选择是否国资" }],
        //经济类型
        economicType: [{ required: true, message: "请选择经济类型" }],
        unifySocialCreditCodes: [
          { required: true, message: "请输入统一信用代码" },
        ],
        legalPerson: [{ required: true, message: "请输入法定代表人" }],
        registeredAddress: [{ required: true, message: "请输入住所" }],
        registeredCapital: [{ required: true, message: "请输入注册资本" }],
        //币种
        currency: [{ required: true, message: "请输入注册资本币种" }],
        //所属集团
        group: [{ required: true, message: "请输入所属集团" }],
        //监管部门
        supervisionDepartment: [{ required: true, message: "请输入监管部门" }],
        isLessor: [{ required: true, message: "请选择是否为出租方" }],
        establishmentDate: [{ required: true, message: "请输入成立日期" }],
        isLongTime: [{ required: true, message: "请选择是否长期经营" }],
        operatingPeriodStartDate: [
          { required: true, message: "请选择营业期限开始日期" },
        ],
        operatingPeriodEndDate: [
          { required: true, message: "请选择营业期限结束日期" },
        ],
        businessScope: [{ required: true, message: "请输入经营范围" }],
      },
      previewVisible: false,
      previewImage: "",
    };
  },
  watch: {
    "formData.isLongTime"(newVal, oldVal) {
      this.formData.operatingPeriodStartDate = undefined;
      this.formData.operatingPeriodEndDate = undefined;
    },
  },
  methods: {
    //币种字典
    currencyDictionaries(visible) {
      if (!visible) return;
      // 已有数据则不再请求
      if (this.dictionaries.currency.length > 0) return;
      //获取字典内容
      this.fetching.currency = true;
      getCurrency()
        .then((res) => {
          if (res && res.code === "200") {
            const list = res.data || [];
            this.dictionaries.currency = this.sortCurrencyList(list);
          }
        })
        .catch((err) => {
          console.error("接口调用异常：", err);
        })
        .finally(() => {
          this.fetching.currency = false;
        });
    },
    //便利性优化排序主流货币
    sortCurrencyList(list) {
      const CURRENCY_PRIORITY = {
        人民币: 1,
        跨境人民币: 2,
        港币: 3,
        澳门元: 4,
        美元: 5,
        欧元: 6,
        英镑: 7,
      };

      return list.slice().sort((a, b) => {
        const pa = CURRENCY_PRIORITY[a.note] || 999;
        const pb = CURRENCY_PRIORITY[b.note] || 999;
        return pa - pb;
      });
    },
    //经济类型字典
    economicTypeDictionaries(visible) {
      if (!visible) return;
      // 已有数据则不再请求
      if (this.dictionaries.economicType.length > 0) return;
      //获取字典内容
      this.fetching.economicType = true;
      getEconomicType()
        .then((res) => {
          if (res && res.code === "200") {
            this.dictionaries.economicType = res.data || [];
          }
        })
        .catch((err) => {
          console.error("接口调用异常：", err);
        })
        .finally(() => {
          this.fetching.economicType = false;
        });
    },
    //营业执照变更
    handleBusinessLicenseChange({ fileList }) {
      fileList = fileList.map((item) => {
        if (item.response != null) {
          if (item.response.code == "200") {
            this.formData.companyName =
              item.response.data.businessLicenseData.companyName;
            this.formData.unifySocialCreditCodes =
              item.response.data.businessLicenseData.unifySocialCreditCodes;
            this.formData.legalPerson =
              item.response.data.businessLicenseData.legalPerson;
            this.formData.registeredAddress =
              item.response.data.businessLicenseData.registeredAddress;
            this.formData.registeredCapital =
              item.response.data.businessLicenseData.registeredCapital;
            this.formData.businessScope =
              item.response.data.businessLicenseData.businessScope;
            return {
              uid: item.uid,
              name: item.name,
              status: "done",
              url: item.response.data.businessLicenseOssUrl,
            };
          }
          if (item.response.code == "400") {
            setTimeout(() => {
              this.$notification["error"]({
                message: "错误",
                description: (item.response || {}).data || {},
                duration: 4,
              });
            }, 300);

            return {
              uid: item.uid,
              name: item.name,
              status: "error",
              url: undefined,
            };
          } else {
            return {
              uid: item.uid,
              name: item.name,
              status: "error",
              url: undefined,
            };
          }
        } else {
          return item;
        }
      });
      this.businessLicense = fileList;
    },

    validateForNextStep() {
      return new Promise((resolve) => {
        // 1️⃣ 校验营业执照是否上传成功
        const uploaded =
          this.businessLicense.length > 0 &&
          this.businessLicense.every((f) => f.status === "done");

        if (!uploaded) {
          this.$notification.warning({
            message: "注意",
            description: "请上传营业执照",
            duration: 4,
          });
          resolve(false);
          return;
        }

        // 2️⃣ 校验表单
        this.$refs.baseForm.validate((valid) => {
          if (!valid) {
            this.$notification.warning({
              message: "注意",
              description: "请先完善企业信息",
              duration: 4,
            });
            resolve(false);
            return;
          }

          // 全部通过
          resolve({
            valid: true,
            data: {
              ...this.formData,
              group: this.formData.group?.label || "",
              groupUnifySocialCreditCodes: this.formData.group?.value || "",
              supervisionDepartment: this.formData.supervisionDepartment?.label || "",
              sdUnifySocialCreditCodes: this.formData.supervisionDepartment?.value || "",
              businessLicense: this.businessLicense,
            },
          });
        });
      });
    },

    //上传
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },

    previewHandleCancel() {
      this.previewVisible = false;
    },
    //开始时间
    disabledRentStartDate(startValue) {
      const endValue = this.formData.operatingPeriodEndDate;
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },

    startDateRentChange(startValue) {
      this.rentList = [];
      const endRentValue = this.formData.operatingPeriodEndDate;
      if (endRentValue != null && startValue != null) {
        const diffInDays = endRentValue.diff(startValue, "days");
        this.rentDay = diffInDays + 1;
      } else {
        this.rentDay = 0;
      }
    },
    //结束时间
    disabledRentEndDate(endValue) {
      const startValue = this.formData.operatingPeriodStartDate;
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    endDateRentChange(endValue) {
      this.rentList = [];
      const startRentValue = this.formData.operatingPeriodStartDate;
      if (startRentValue != null && endValue != null) {
        const diffInDays = endValue.diff(startRentValue, "days");
        this.rentDay = diffInDays + 1;
      } else {
        this.rentDay = 0;
      }
    },

    //点击所属集团树搜索下拉框
    async handleAffiliatedTreeVisible() {
      // 已加载过，直接用
      if (this.affiliatedOriginTreeData.length > 0) {
        this.affiliatedTreeSearchValue = "";
        // 重置树展示
        this.affiliatedTreeData = this.affiliatedOriginTreeData;
        return;
      }
      //首次加载，调用后端接口获取联交所 所属企业字典
      this.affiliatedTreeLoading = true;
      try {
        const res = await getOrgTree();
        if (res.code !== "200") return;
        //将后端树结构映射成ant-vue的书接口
        const tree = this.mapToAffiliatedTreeSelect(res.data);

        this.affiliatedOriginTreeData = tree;
        this.affiliatedTreeData = tree;
      } catch (e) {
        console.error("所属集团树加载失败", e);
      } finally {
        this.affiliatedTreeLoading = false;
      }
    },
    /**
     * 后端树数据 → TreeSelect 树数据
     * CODE → value / key
     * NAME → title
     */
    mapToAffiliatedTreeSelect(data = [], parentKey = "") {
      return data.map((item, index) => {
        const currentKey = item.ID;

        const children = Array.isArray(item.children)
          ? this.mapToAffiliatedTreeSelect(item.children, currentKey)
          : [];

        // ⭐ 核心业务规则
        const canSelect = String(item.FILL_TYPE_CODE) === "2";

        return {
          title: item.NAME || item.CODE,
          key: currentKey,
          value: item.CODE, // 统一社会信用代码，提交主平台时使用
          // 是否可选，完全由业务字段决定
          selectable: canSelect,
          disabled: !canSelect,
          children,
        };
      });
    },
    //搜索树结构内容
    onAffiliatedTreeSearch(value) {
      this.affiliatedTreeSearchValue = value;

      if (!value) {
        // 清空搜索 → 恢复完整树
        this.affiliatedTreeData = this.affiliatedOriginTreeData;
        this.treeExpandedKeys = ["ROOT"];
        return;
      }

      const expandedKeys = [];
      const filteredTree = this.filterTreeByKeyword(
        this.affiliatedOriginTreeData,
        value,
        expandedKeys
      );

      this.affiliatedTreeData = filteredTree;
      this.treeExpandedKeys = expandedKeys;
    },

    //点击监管部门树搜索下拉框
    async handleRegulatoryTreeVisible() {
      // 已加载过，直接用
      if (this.regulatoryOriginTreeData.length > 0) {
        this.regulatoryTreeSearchValue = "";
        // 重置树展示
        this.regulatoryTreeData = this.regulatoryOriginTreeData;
        return;
      }
      //首次加载，调用后端接口获取联交所 所属企业字典
      this.regulatoryTreeLoading = true;
      try {
        const res = await getOrgList();
        if (res.code !== "200") return;
        //将后端树结构映射成ant-vue的书接口
        const tree = this.mapToRegulatoryListSelect(res.data);
        this.regulatoryOriginTreeData = tree;
        this.regulatoryTreeData = tree;
      } catch (e) {
        console.error("监管部门加载失败", e);
      } finally {
        this.regulatoryTreeLoading = false;
      }
    },
    /**
     * 后端树数据 → TreeSelect 树数据
     * CODE → value / key
     * NAME → title
     */
    mapToRegulatoryListSelect(data = []) {
      const seenCode = new Set();

      return (
        data
          // ① 业务过滤：只保留可选组织
          .filter((item) => String(item.FILL_TYPE_CODE) !== "1")
          // ② CODE 去重：只保留第一次出现的
          .filter((item) => {
            if (seenCode.has(item.CODE)) return false;
            seenCode.add(item.CODE);
            return true;
          })
          // ③ 标准化映射
          .map((item) => ({
            key: item.ID,
            title: item.NAME,
            value: item.CODE,
          }))
      );
    },

    // 搜索监管部门（兼容 list / tree）
    onRegulatoryTreeSearch(value) {
      this.regulatoryTreeSearchValue = value;

      if (!value) {
        this.regulatoryTreeData = this.regulatoryOriginTreeData;
        this.regulatoryTreeExpandedKeys = [];
        return;
      }

      const expandedKeys = [];

      const filtered = this.filterTreeByKeyword(
        this.regulatoryOriginTreeData,
        value,
        expandedKeys
      );

      this.regulatoryTreeData = filtered;
      this.regulatoryTreeExpandedKeys = expandedKeys;
    },

    /**
     * 通用 Tree / List 模糊搜索
     * - 支持 tree / list
     * - 忽略大小写
     * - 自动维护 expandedKeys
     */
    filterTreeByKeyword(tree = [], keyword, expandedKeys = []) {
      const result = [];
      const searchText = (keyword || "").toLowerCase().trim();

      tree.forEach((node) => {
        const title = (node.title || "").toLowerCase();
        const titleMatch =
          title.includes(searchText) || this.fuzzyMatch(title, searchText);

        const hasChildren =
          Array.isArray(node.children) && node.children.length > 0;

        // ===== list 模式 =====
        if (!hasChildren) {
          if (titleMatch) {
            result.push({ ...node });
          }
          return;
        }

        // ===== tree 模式 =====
        const filteredChildren = this.filterTreeByKeyword(
          node.children,
          searchText,
          expandedKeys
        );

        if (titleMatch || filteredChildren.length > 0) {
          result.push({
            ...node,
            children: filteredChildren,
          });

          if (filteredChildren.length > 0) {
            expandedKeys.push(node.key);
          }
        }
      });

      return result;
    },

    //模糊查询组件
    fuzzyMatch(text, keyword) {
      let t = 0;
      for (let k = 0; k < keyword.length; k++) {
        t = text.indexOf(keyword[k], t);
        if (t === -1) return false;
        t++;
      }
      return true;
    },
  },
};
</script>

<style scoped>
.identity-verification {
  padding: 20px;
}

.verification-content {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.qr-section {
  text-align: center;
}

.left-section {
  width: 38%;
}

.right-section {
  width: 58%;
}

.vertical-divider {
  width: 1px;
  background-color: #e8e8e8;
  margin: 0 20px;
}

.upload-item {
  margin-bottom: 20px;
  margin-top: 10px;
}

.upload-box {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.upload-icon {
  font-size: 24px;
  color: #1890ff;
  margin-right: 10px;
}

.upload-btn {
  margin-top: 10px;
}

.personal-info {
  background-color: #f9f9f9;
  padding: 10px;
  border-radius: 5px;
}

.info-item {
  display: flex;
  margin-bottom: 24px;
}

.label {
  font-weight: bold;
  margin-right: 10px;
}

.error-msg {
  color: red;
  font-size: 12px;
}

.action-buttons {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
/* 输入框高度统一 */
.right-section /deep/ input.ant-input {
  height: 32px !important;
  border-radius: 4px;
}
::v-deep .right-section .ant-form-item {
  margin-bottom: 10px !important; /* 自己改 */
}
::v-deep .ant-affix {
  width: 300px !important;
}
</style>
